var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWomen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "women",
    transform: "translate(-510 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(510 169)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "women_safety",
    "data-name": "women safety",
    transform: "translate(172 -113.567)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(346 290.567)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15970",
    "data-name": "Group 15970",
    transform: "translate(115.358 -147.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15969",
    "data-name": "Group 15969",
    transform: "translate(236.642 459.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27659",
    "data-name": "Path 27659",
    d: "M-1396.693,2441.31h-4.045a.585.585,0,0,1-.585-.585.585.585,0,0,1,.585-.584h4.045a.8.8,0,0,0,.429-.106.576.576,0,0,1,.161-.138c.192-.112.147-.584.086-.747-.249-.334-.37-.334-.45-.334h-1.315l-.309,0a8.205,8.205,0,0,1-3.322-.534l-.313-.108c-.506-.171-.849-.279-1.37-.44l-.5-.157c-2.662-.834-4.444,2.163-4.462,2.194a.584.584,0,0,1-.8.211.584.584,0,0,1-.211-.8,7.3,7.3,0,0,1,1.527-1.753,4.442,4.442,0,0,1,4.294-.967l.5.156c.529.164.878.273,1.4.449l.32.11a7.084,7.084,0,0,0,2.924.47l.312,0h1.327a1.737,1.737,0,0,1,1.4.828,2.039,2.039,0,0,1,.239,1.378,1.459,1.459,0,0,1-.6,1A1.8,1.8,0,0,1-1396.693,2441.31Z",
    transform: "translate(1414.221 -2435.793)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27660",
    "data-name": "Path 27660",
    d: "M-1402.982,2444.612l.007-.008-.857-.8a3.75,3.75,0,0,1,1.429-.833,10.234,10.234,0,0,1,4.563-.377,17.553,17.553,0,0,0,2.668.1,7.45,7.45,0,0,0,4.366-1.74,7.614,7.614,0,0,0,1.7-2.084,5.115,5.115,0,0,0,.414-1.193l0-.007c.039-.147.145-.643.212-1.036a2.27,2.27,0,0,0-.471.049,3.764,3.764,0,0,0-.812.974,4.879,4.879,0,0,1-.929,1.184,3.129,3.129,0,0,1-2.833.88l.236-1.145a1.971,1.971,0,0,0,1.779-.57,3.792,3.792,0,0,0,.72-.906l.018-.033c.278-.463.944-1.367,1.493-1.508a3.409,3.409,0,0,1,.828-.1h.029a1.305,1.305,0,0,1,.947.264.675.675,0,0,1,.219.568,13.967,13.967,0,0,1-.3,1.671,6.126,6.126,0,0,1-.518,1.459,8.739,8.739,0,0,1-1.988,2.43,8.623,8.623,0,0,1-5.065,2.005,18.682,18.682,0,0,1-2.837-.106C-1401.685,2443.359-1402.969,2444.6-1402.982,2444.612Z",
    transform: "translate(1412.078 -2435.469)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27658",
    "data-name": "Path 27658",
    d: "M-1412.545,2449.509a.585.585,0,0,1-.51-.3.585.585,0,0,1,.223-.8l3.427-1.927-3.805-6.926-3.658,2.161a.585.585,0,0,1-.8-.206.584.584,0,0,1,.206-.8l4.177-2.468a.585.585,0,0,1,.452-.061.583.583,0,0,1,.358.282l4.374,7.962a.584.584,0,0,1-.226.791l-3.932,2.211A.587.587,0,0,1-1412.545,2449.509Z",
    transform: "translate(1417.75 -2436.576)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15968",
    "data-name": "Group 15968",
    transform: "translate(240.039 439.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27666",
    "data-name": "Path 27666",
    d: "M-1317.1,2432.45l-1.439-.034c0-.026.06-2.593.044-5.277,0-.168,0-.4,0-.659,0-.852-.009-2.018-.021-2.858v-.042c.144-3.19-.91-4.687-1.552-5.295l0,0c-.5-.482-3.148-2.8-6.274-1.2a6.3,6.3,0,0,0-3.178,4.885c-.1,1.091-.006,4.691-.005,4.727v5.737h-1.44v-5.708c-.007-.254-.1-3.732.011-4.886a7.734,7.734,0,0,1,3.9-6.007l.034-.018c4-2.071,7.319.82,7.949,1.427.818.777,2.163,2.637,2,6.381.011.846.017,2,.021,2.85,0,.263,0,.489,0,.657C-1317.04,2429.837-1317.1,2432.424-1317.1,2432.45Z",
    transform: "translate(1333.974 -2415.077)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27663",
    "data-name": "Path 27663",
    d: "M-1333.651,2440.751h-1.44a3.253,3.253,0,0,1,.51-1.6,4.5,4.5,0,0,1,3.307-1.949,8.358,8.358,0,0,0,3.144-1.008c.253-.164.678-.493.678-.863h1.44c0,.921-.653,2.574-5.028,3.292C-1333.621,2439.04-1333.651,2440.734-1333.651,2440.751Z",
    transform: "translate(1335.091 -2420.445)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27664",
    "data-name": "Path 27664",
    d: "M-1327.452,2440.761a1.925,1.925,0,0,0-.33-.912,3.217,3.217,0,0,0-2.28-1.231c-4.375-.718-5.028-2.37-5.028-3.292h1.44c0,.37.425.7.678.863a8.359,8.359,0,0,0,3.144,1.008,4.5,4.5,0,0,1,3.306,1.949,3.253,3.253,0,0,1,.51,1.6h-1.44Z",
    transform: "translate(1345.984 -2420.445)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27665",
    "data-name": "Path 27665",
    d: "M-1323.1,2441.56c-2.778,0-4.86-2.729-4.949-2.846l1.15-.866c.017.023,1.745,2.273,3.8,2.273h.067c1.146-.028,2.235-.783,3.237-2.245l1.188.813c-1.28,1.869-2.76,2.835-4.4,2.871Z",
    transform: "translate(1333.198 -2421.241)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27662",
    "data-name": "Path 27662",
    d: "M-1323.181,2421.229a.717.717,0,0,1,.413.13l4.583,3.213a.72.72,0,0,1,.3.674,17.134,17.134,0,0,1-.924,3.676c-1.258,3.277-3.05,3.965-4.332,3.965h-.052c-4.282-.061-5.6-6.934-5.649-7.227a.721.721,0,0,1,.286-.714l4.951-3.582A.719.719,0,0,1-1323.181,2421.229Zm3.805,4.266-3.8-2.663-4.154,3.005a14.755,14.755,0,0,0,.932,2.711c.894,1.906,1.979,2.882,3.225,2.9h.031c1.5,0,2.455-1.654,2.988-3.041A15.77,15.77,0,0,0-1319.376,2425.5Z",
    transform: "translate(1333.382 -2416.761)",
    fill: "#006"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.164fd4353c57a4a14d880325edd29d7b.svg";
export { ForwardRef as ReactComponent };